var Marionette = require('marionette'),
    $ = require('jquery'),
    Raphael = require('raphael'),
    BaseDrawFns = require('./baseCanvasDrawFns'),
    CanvasDrawFns = require('./canvasDrawFunctions'),
    fvChannel = require('glRadio').channel('FV'),
    CreateGraphicStampEl = require('./shape/graphicStamp/createImgEl');

require('backbone.mousetrap');


var instVars = {
    shapeViews: null,
    containerAbs: null, // bounds of the view offset from the window (not starting at 0,0)
    containerRel: null, // 'relative' bounds of the view; starts at 0,0, and includes current dimensions
    paper: null
};

// more dynamic added:
    // mouseModel -- store the others on here?

    //shape -- if a shape is being drawn, its the raphael el
    //drawStart, drawStop, drawMove
    //drawRect
        //dummyRectBorder
        //osw
    //polyHelper
        //this.currentPathString, line, free
    //this.textAreaView (text area before it becomes a text shape -- can't have more than 1)

    //hoverShape (if create signature or stamp)


module.exports = Marionette.ItemView.extend({

    className: 'canvasWr', // can't add class to svg

    initialize: function(options) {

        _.extend( this, instVars, _.pick( options, 'channel'), {
            shapeViews: new Backbone.ChildViewContainer() // must recreate on init -- otherwise reference error if more than 1 canvas (eg from find and redact -- canvas's will share the view )
        });

        // el is already created; set up everything possible prior to appended to DOM
        // note: the container must be the underlying div, not the svg element!
        this._preDOMRender();

    },

    keyboardEvents: {
        'backspace'    : '_deleteSelectedShapeFromHotkey',
        'del'          : '_deleteSelectedShapeFromHotkey'
    },

    _preDOMRender: function( ) {

        this.paper = this._renderPaper();

        if ( this.channel.request('getPage').get('overlay') ) {
            this._applyOverlayAdjustments();
        }

        /* DVBC-893 bizarre hack -- need underlay with box shadow for IE<10 -- also allows not to put the image in the same layer as the canvas */
        fvChannel.request('settings').isIE &&
            this.$el.append($('<div class="IE-canvas-drawing-shim"></div> '));

    },

    /* Note: paper isn't the el, the canvasWr is */
    _renderPaper: function() {

        var paper = new Raphael(this.el, '100%', '100%');
        paper.customAttributes = Raphael.fn.customAttributes;
        $(paper.canvas)
            .removeAttr('style') /* remove what output from raphael by default */
            .attr('class', 'img-paper-canvas');

        return paper;

    },

    // Now also handles edit/mode, etc
    // Set bounds here so we can place the initial render with a call to what's now 'reRender' shapes (doesn't hurt)
    _renderShapes: function(shapes) {

        this._setBounds();

        var scale = this.channel.request('currentScaleValue');

        shapes instanceof Backbone.Collection &&
            (shapes = shapes.models);

        _.each(shapes, function(s) {
            this.renderShapeViewFromModel(s, scale, true);
        }, this);


        /* -- Layering -- */

        /**
         * For Floating Codes Positioning -- the code views must be positioned above all shapes.
         * This can't be done until all shapes have been rendered on the canvas --
         * Only then will be know the 'top'. ( Setting to-front manually won't work as this is called sequentially )
         * We probably want a more organized way of positioning shapes, etc ... but this will have to do for now.
         * ( Main problem is we don't store a position in the db ).
         *  Any other layering logic may want to be centralized here,
         *  if we have more in the future (other than code views go atop other shapes).
         */
        this.channel.trigger('imgCanvas.moveAllCodeBoxesToFront', this.paper);


        /**
         * Now handle logic of 'layering' full page redactions, if they exist on the page.
         * Do after the floating codes.
         * Could  do more elegantly (model driven by determining the rendering order of the shape first and storing on a model, then, rendering them
         * all, though the order is really that from the shape collection, so this should work.
         *  Note: there can only be one full page redaction note on a page.
         */
        var fullPageRedactionShape = _.find(shapes, function(s) {
            return s.parentNote.isFullPageRedactionNote();
        });

        if ( fullPageRedactionShape )
            fullPageRedactionShape.uiModel.trigger( 'fullPgRedactionShape:layerAfterShapesRendered' );


    },

    /**
     * Central pt for creation.
     * Creates a new shape view from given a shape model
     * From both initial render of models AND immediately after 'addNewlyDrawnShape'
     */
    renderShapeViewFromModel: function(shape, pgScaleVal, fromModel) {

        var note = shape.getParentNote(),
            channel = this.channel,
            scale = pgScaleVal,
            shapeView = note.shapeView({ /* Note -- this is an xref -- change when the individual shape models */
                parent: this,
                shapeModel: shape,
                pgNoteModel: note,
                scale: scale,
                channel: channel
            });

        shapeView.render(shape, scale, channel, fromModel);
        this.shapeViews.add(shapeView);

        return shapeView;

    },
    // Only called from canvas.deleteShape -- the central point of shape deletion
    destroyShapeView: function(shape, manualUserDelete) {

        var v = this.shapeViewFromModel(shape);
        this.shapeViews.remove(v);

        // Note: we are destroying the views, not the models.  This is important now for full page redactions,
        // (DVBC-1762) where the shape model is stored on the note model.  It could later be important if we
        // start using the same approach for other shape types -- otherwise you'd need to
        // create new shape object and potentially re-render note views on activeNoteChange, for example.
        v.destroy(manualUserDelete);

    },
    shapeViewFromModel: function(shape) {
        return this.shapeViews.find(function(v) {
            return v.shapeModel === shape;
        });
    },
    onUpdateScale: function( curScale, prevScale, options ) {

        var args = Array.prototype.slice.call(arguments);

        if ( options && options.updateCanvasOverlay ) {
            this._applyOverlayAdjustments( options.pageModel, curScale);
        }

        this._setBounds();
        this.shapeViews.apply( 'trigger', ['shape.scaleWithPaper'].concat(args) ); // perf hit but keep mediation strategy clear


        // For performance, perhaps combine all these events
        this.channel.trigger.apply( this.channel, ['scaleFloatingReasonCodeViews'].concat(args) );

        // Hovers tamp and Hover Signature
        this.channel.trigger.apply( this.channel, ['hoverShape:scale'].concat(args) );

        // (textAreaView is not one of the shapeViews)
        this.channel.trigger.apply( this.channel, ['textAreaView.scaleWithPaper'].concat(args) );

    },
    /* overlay offsets AND potentially height and width*/
    _applyOverlayAdjustments: function( pageModel, currentScale ) {

        pageModel = pageModel || this.channel.request('getPage');
        currentScale = currentScale || this.channel.request('currentScaleValue');

        var overlay = pageModel.get('overlay'),
            actualDimensions = pageModel.get( 'textGridModel' ).actualDimensions( currentScale );

        this.$el.css({
            left: (overlay.xTextOffset * currentScale) + 'in',
            top: (overlay.yTextOffset * currentScale) + 'in',
            width: actualDimensions.width + 'px', //(scale already adjusted) from fn in view
            height: actualDimensions.height + 'px'
        });

    },

    // implies the user is 'drawing', occurs if rendered with an active note set
    enterEditMode: function(note) {

        // cursor: default -- this is now not necessary,
        // you can't draw shapes new shapes unless you hit toggle active note; in this mode cursor will be default

        var pnClass = note.getNoteClass(),
            noteSubType = note.getDefaultShapeSubType(); //this is what the draw functions are based on

        this.$el
            .addClass('edit-mode ' + pnClass)
            .data('init', pnClass);

        if ( note.supportsHoverShape() ) {

            // Note: DVBC-1763 -- can't combine note.isNew() with above predicate,
            // otherwise on modify, the final else is reached, drawing is enabled,
            // and an extra hoverstamp is created.
            // Note: Signature's can't be modified -- will always be new.
            // !note.isPersistingShapeModelAttributesDuringCanvasRerender: don't if a unsaved shape (that has been placed) from a note that will be re-rendered.
            if ( note.isNew() && !note.isPersistingShapeModelAttributesDuringCanvasRerender && !this.hoverShape ) {
                this._enableDrawing(noteSubType, note);
            }

        } else {

            this._enableDrawing(noteSubType, note);
        }

    },


    // Still needed because not destroying and re-creating the view ...
    // Called at beginning re-render shapes (with is like the view reset) ... area for refactor
    // More like a reset called first on reRender shapes
    _exitEditMode: function() {

        this.$el
            .removeClass('edit-mode ' + this.$el.data('init') + ' text-cursor')
            .removeClass('default-cursor'); // this is only for hover shape ( can't place another )

        this._disableDrawing();

    },


    /*--- ---*/

    /**
     *   For now left as intermediary refactor, left seperate from enterEditMode, exitEditMode.
     *   There should be a combined pre and post shape 'render function' that is combined with the above
     *   on re-render shapes -- resets the state of this view depending on the presence of these notes.
     *   Here, this is only called if there is not activeNote ( not in edit mode ); that logic is now in the
     *   canvas module. See comment there for interaction with drawStart ( which accomplishes this if in edit mode ).
     *
     *   If we click on the canvas, unless we select a button (it could be the current shapes select button), unselect the shape.
     *   Issue: this breaks drag functionality -- drag is an outer html element and it's mouse will get called,
     *   which will also unselect the shape.
     *   We want to only unselect if the event is not from the drag.
     */

    setUnselectedShapeHandlerForFindAndRedact: function() {

        this.$el.on( 'mousedown', _.bind( function(e) { // use mousedown -- consistent with other methods ...

            e.preventDefault();

            // Without stopping propagation, a second event will be called from the parent drag container.
            // So the problem is that if you drag, it will unselect the shape.
            // We want to unselect the shape, but not if we are dragging.
            // e.stopPropagation(); // this would prevent drag scrolling
            // I think you'd need to capture, the drag event 1st ( to say don't do the hide, but it happens 2nd ) -- otherwise this is very confusing and not worth it
            // Maybe we don't do it ... could also trying not using mousedown but a click event which would occur after

            var rId = e.target.raphaelid;
            if (rId && this.paper.getById(rId).data('shapeType') === 'button')
                return;

            this.channel.command('setSelectedShape', null);

        }, this ));


    },

    unsetSelectHandlerForFindAndRedact: function() {
        this.$el.off('mousedown');
    },


    /*---  ---*/

    _deleteSelectedShapeFromHotkey: function(e) {
        e.preventDefault(); // Don't allow backspace to go to last page
        var selectedShape = this.channel.request('selectedShape');
        selectedShape && this.channel.command('deleteShape', selectedShape, 1);
    },

    /**
     * Also deals with subType change ( in addition to active note change; really need to refactor this )
     * Handles mousedown on view and unselecting shapes ( in drawStart )
    */
    _enableDrawing: function( subType, note ) {

        /* temp fix for drawing the hover-signature b/f the canvas is rendered */
        if (!this.paper)
            return false;

        this._disableDrawing(); //(clear in case) -- note: doesn't fix problem of not being able to edit post page change
        this.$el[(subType === 'text') ? 'addClass' : 'removeClass']('text-cursor');  //(also small code for changing subtype)

        // with new shape types (eg text shape, signature, graphic stamp ... may not always want this ... again more refactor ...
        _.extend( this, CanvasDrawFns[subType] ); // why not just change prototype?
        _.bindAll(this, 'drawStart', 'drawStop', 'drawMove');

        this.$el.on( 'mousedown', this.drawStart );

        /* must do after extension of drag fns   ... off('mousedown', this.model.unselectAllShapes ) ? */
        /* note: needed (opposed to just draw start, b/c need to capture position of click from mouse event */

        if ( note.supportsHoverShape() ) {
            this.createHoverShape( note );
        }

    },
    _disableDrawing: function() {

        this.$el
            .off('mousedown', this.drawStart)
            .off('mousemove', this.drawMove)
            .off('mouseup', this.drawStop);

        // Handles case where changeNoteType, cancel note, save note, modeChange, pageChange, selectShape (but not another text shape)
        this.channel.command('destroyTextArea');

        /**
         * TODO: really need to clean all these plugs ...
         * hoverShape 'flag' (really the 'hover view' now implies Graphic Stamps and Signatures ( and now Text Stamps )
         * Same hack to remove the hoverShape as hoverSignature if user cancel creating the note when creating it
         * Only doing if already created (and would only exist if type is signature/stamp), on exit subtype is undefined )
         * Only do on exit.
         * Destroy: if note cancelled, before placed, this will still exist --> mem leaks, etc.
         * TODO: put listener on the hover shape ?
         *
         */
        this.hoverShape
            && !this.channel.request('editMode')
            && this.destroyHoverShape();

    },


    getMousePos: function(e) {

        var offset = this.$el.offset();
        return {
            x: e.pageX - offset.left,
            y: e.pageY - offset.top
        };

    },
    _setBounds: function() {

        var $el = this.$el,
            ht = $el.height(),
            wt = $el.width(),
            $offset = $el.offset(),
            left = $offset.left,
            top = $offset.top;

        this.containerAbs = {
            x: left,
            x2: left + wt,
            y: top,
            y2: top + ht
        };

        this.containerRel = {
            x: 0,
            y: 0,
            x2: wt,
            y2: ht
        };

    },

    // the abs position (rel to doc)-- for draw and drag
    // TODO: may no longer be working as intended -- eg: when drawing line we're always in bounds (forget original intention)
    mouseInBounds: function(x, y) {

        var box = this.containerAbs,
            outOfBounds = x <= box.x || x >= box.x2 || y <= box.y ||  y >= box.y2;

        return !outOfBounds;

    },
    baseDraw: BaseDrawFns,
    destroyTextAreaView: function() {

        if (!this.textAreaView)
            return;

        this.textAreaView.destroy();
        this.textAreaView = null;
        delete this.textAreaView;

    },
    // Occurs when user is modifying a stamp and changes the stamp image
    graphicStampChanged: function(stamp, note) {

        if ( this.hoverShape ) {

            // I don't think need to call enable/disable drawing; this appears to just work ( must be in edit mode for it to exist )
            // This would occur for new, unsaved notes where the stamp has yet to have been placed
            this.destroyHoverShape();
            this.createHoverShape( note );

        } else {

            var currentShapeModel = this.channel.request('selectedShape'),
                currentShapeBbox = currentShapeModel.uiModel.getBBoxOfEl(),
                scale = this.channel.request('currentScaleValue');

            //TODO: check if this reset the state, eg the selected shape (maybe put that in there, could be mem leaks) ...
                // ( now see text stamp change where we set to null ... )
            // go through code ... maybe a better way to accomplish this
            // brief look shows there doesn't appear to be mem leak
            this.channel.command('deleteShape', currentShapeModel);

            this.shape = CreateGraphicStampEl(
                this.paper,
                stamp.getImgSrc(),
                currentShapeBbox.x,
                currentShapeBbox.y,
                stamp.getWidth() * scale,
                stamp.getHeight() * scale
            );

            // TODO: also make sure it's in bounds (?); the size of the new shape could go outside it
            this.channel.command( 'addNewlyDrawnShape', this.shape ); // ( this will also select it )
        }

    },

    // still small mem leak when switch pages
    // ... this may want cleanup now and it could have overlap with canvas.destroy
    onBeforeDestroy: function() {

        this.$el.off(); // eg mousedown for unselect shapes

        this.channel.command('deleteAllShapes');
        this.channel.reset();

        this.shapeViews.call('destroy'); // this is breaking it -- it destroy shapeViews on the other canvas ... are they the same

        this.shapeViews.each(function(sv) {
            this.shapeViews.remove(sv);
        }, this);

    }
});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/imgCanvas.js
 ** module id = 359
 ** module chunks = 0
 **/